exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkbox {\n  width: 15px;\n  height: 15px;\n  margin: 5px;\n}\n\n.table{\n  margin-top: 15px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal/content-updated-info.component.css
// module id = 839
// module chunks = 0